module.exports = __webpack_public_path__ + "static/media/githubImg.7f867bbf.png";